import { AppNodes } from '@models/enums/dvm/DvmNodes.enum';
import { z } from 'zod';

const RandomAvailabilityApplyToSchema = z.nativeEnum(AppNodes);

const PercentagesSchema = z.record(RandomAvailabilityApplyToSchema, z.number().min(0).max(100));

export const CustomAvailabilityRecordSchema = z.record(
  z.nativeEnum(AppNodes),
  z.array(z.string())
);

export const RandomAvailabilitySchema = z.object({
  enabled: z.boolean(),
  applyTo: z.array(RandomAvailabilityApplyToSchema).optional(),
  percentages: PercentagesSchema.optional(),
});

export const CustomAvailabilitySchema = z.object({
  enabled: z.boolean(),
  data: CustomAvailabilityRecordSchema,
});

export const AvailabilitySchema = z.union([
  RandomAvailabilitySchema,
  CustomAvailabilitySchema,
]);

export type Availability = z.infer<typeof AvailabilitySchema>;
